import {
	Directive,
	Input,
	OnDestroy,
	TemplateRef,
	ViewContainerRef,
} from '@angular/core';
import { Subscription } from 'rxjs';
import { SessionService } from '@app/services';

@Directive({
	selector: '[appRestrictedByScope]',
})
export class RestrictedByScopeDirective implements OnDestroy {
	private subscription: Subscription;

	@Input()
	set appRestrictedByScope(scope: { model: string; action: string }) {
		if (this.subscription) {
			this.subscription.unsubscribe();
		}

		this.subscription = this.sessionService.getSelf().subscribe((self) => {
			if (self && self.checkPermission(scope.model, scope.action)) {
				this.viewContainer.createEmbeddedView(this.templateRef);
			} else {
				this.viewContainer.clear();
			}
		});
	}

	constructor(
		private viewContainer: ViewContainerRef,
		private templateRef: TemplateRef<any>,
		private sessionService: SessionService
	) {}

	ngOnDestroy(): void {
		if (this.subscription) {
			this.subscription.unsubscribe();
		}
	}
}
